import { useEffect, useState } from 'react';

const BUTTON_SELECTOR = '#onetrust-consent-sdk button';
const COOKIE_GROUPS = ['C0002', 'C0004', 'C0005'];

const cookiesEnabled = () => {
  return !!(
    window.OptanonActiveGroups &&
    // check if any of these consents is given
    COOKIE_GROUPS.some((cookie) => window.OptanonActiveGroups?.includes(cookie))
  );
};

export const useOneTrustObserver = () => {
  const [oneTrustEnabled, setOneTrustEnabled] = useState<boolean>();

  const enableOneTrust = () => {
    if (cookiesEnabled()) {
      setOneTrustEnabled(true);
    }
  };

  const loadAfterOneTrust = new MutationObserver((mutations, me) => {
    if (cookiesEnabled()) {
      me.disconnect();
      setOneTrustEnabled(true);
    } else {
      const oneTrustBtns = document.querySelectorAll(BUTTON_SELECTOR);
      if (oneTrustBtns.length > 0) {
        me.disconnect();
        oneTrustBtns.forEach((oneTrustBtn) => oneTrustBtn.addEventListener('click', enableOneTrust));
      }
    }
  });

  useEffect(() => {
    loadAfterOneTrust.observe(document, {
      childList: true,
      subtree: true
    });
    return () => {
      loadAfterOneTrust.disconnect();
      const oneTrustBtns = document.querySelectorAll(BUTTON_SELECTOR);
      oneTrustBtns.forEach((oneTrustBtn) => oneTrustBtn.removeEventListener('click', enableOneTrust));
    };
  });

  return oneTrustEnabled;
};
